module.exports = __webpack_public_path__ + "static/media/byttelydStartingtest.5c019804.mp3";